import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { UtensilsCrossed } from "lucide-react";

const KEY = "p400_table";
export const getTable = () => sessionStorage.getItem(KEY) || "";

export const TableBanner = () => {
  const [params] = useSearchParams();
  const table = params.get("tavolo");

  useEffect(() => {
    if (table) {
      sessionStorage.setItem(KEY, table);
    }
  }, [table]);

  const current = table || getTable();
  if (!current) return null;
  return (
    <div className="bg-accent text-accent-foreground" data-testid="table-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 text-sm flex items-center gap-2">
        <UtensilsCrossed className="h-4 w-4 shrink-0" /><span>Sei al <strong>tavolo {current}</strong>: il numero verrà aggiunto alle note dell'ordine.</span>
      </div>
    </div>
  );
};
